module.exports = __webpack_public_path__ + "img/connectAccountIcon.3217a39b.svg";